import React from "react";
import AppBarMenu from "../../components/AppBarMenu";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import AttorneyDedicatedForm from "../../components/management/attorney/AttorneyDedicatedForm";

/**
 * Página dedicada para gestão de procurações
 */
export default function AttorneysPage() {
  return (
    <AppBarMenu>
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper
              sx={{
                p: 3,
                display: "flex",
                flexDirection: "column",
                minHeight: 600,
              }}
            >
              <AttorneyDedicatedForm />
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </AppBarMenu>
  );
}
